(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tabela-preco"] && !Shopify.designMode) return;
  try {
    (function() {
  const priceTables = document.querySelectorAll('.sf-price-table[data-product-id]');
  
  priceTables.forEach(function(table) {
    const slider = table.querySelector('.sf-price-table__quantity-slider');
    if (!slider) return;
    
    const quantityValue = table.querySelector('.sf-price-table__quantity-value');
    const pixPriceEl = table.querySelector('[data-pix-price]');
    const cardPriceEl = table.querySelector('[data-card-price]');
    const installmentValueEl = table.querySelector('[data-installment-value]');
    const comparePriceEl = table.querySelector('[data-compare-price]');
    const plusTextEls = table.querySelectorAll('[data-plus-text]');
    
    const basePrice = parseInt(table.dataset.basePrice) || 0;
    const comparePrice = parseInt(table.dataset.comparePrice) || 0;
    const pixDiscount = parseFloat(table.dataset.pixDiscount) || 0;
    const installments = parseInt(table.dataset.installments) || 0;
    const plusDiscount = parseFloat(table.dataset.plusDiscount) || 0;
    const isPrimeCustomer = table.dataset.isPrimeCustomer === 'true';
    const showIndividualDiscount = table.dataset.showIndividualDiscount === 'true';
    const min = parseInt(slider.min) || 1;
    const max = parseInt(slider.max) || 100;
    const bulkDiscountBadge = table.querySelector('[data-bulk-discount-badge]');
    const bulkDiscountText = table.querySelector('[data-bulk-discount-text]');
    
    // Parse bulk discount rules
    let bulkRules = [];
    try {
      const rulesJson = table.dataset.bulkRules || '[]';
      bulkRules = JSON.parse(rulesJson).filter(function(rule) {
        return rule.qty > 0 && rule.discount > 0;
      }).sort(function(a, b) {
        return a.qty - b.qty;
      });
    } catch (e) {
      console.error('Error parsing bulk rules:', e);
    }
    
    function getBulkDiscount(quantity) {
      let applicableDiscount = 0;
      for (let i = bulkRules.length - 1; i >= 0; i--) {
        if (quantity >= bulkRules[i].qty) {
          applicableDiscount = bulkRules[i].discount;
          break;
        }
      }
      return applicableDiscount;
    }
    
    function formatMoney(cents) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(cents / 100);
    }
    
    function updatePrices(quantity) {
      // Get bulk discount for this quantity
      const bulkDiscount = getBulkDiscount(quantity);
      
      // Calculate base total price
      let totalPrice = basePrice * quantity;
      const totalComparePrice = comparePrice * quantity;
      
      // Apply Prime discount first if customer is Prime
      if (isPrimeCustomer && plusDiscount > 0) {
        const primeDiscountValue = totalPrice * (plusDiscount / 100);
        totalPrice = totalPrice - primeDiscountValue;
      }
      
      // Apply bulk discount if applicable
      if (bulkDiscount > 0) {
        const bulkDiscountValue = totalPrice * (bulkDiscount / 100);
        totalPrice = totalPrice - bulkDiscountValue;
      }
      
      // Update quantity display
      if (quantityValue) {
        quantityValue.textContent = quantity + ' un.';
      }
      
      // Update bulk discount badge
      if (bulkDiscountBadge && bulkDiscountText) {
        if (bulkDiscount > 0) {
          if (showIndividualDiscount) {
            // Mostrar desconto individual
            bulkDiscountText.textContent = 'Unidade com ' + bulkDiscount + '% OFF';
          } else {
            // Mostrar desconto total
            bulkDiscountText.textContent = '-' + bulkDiscount + '%';
          }
          bulkDiscountBadge.style.display = 'block';
        } else {
          bulkDiscountBadge.style.display = 'none';
        }
      }
      
      // Update slider fill
      const fillPercent = ((quantity - min) / (max - min)) * 100;
      slider.style.setProperty('--slider-fill-percent', fillPercent + '%');
      
      // Calculate individual price with Prime and bulk discounts
      let individualPrice = basePrice;
      
      // Apply Prime discount first if customer is Prime
      if (isPrimeCustomer && plusDiscount > 0) {
        const primeDiscountValue = individualPrice * (plusDiscount / 100);
        individualPrice = individualPrice - primeDiscountValue;
      }
      
      // Apply bulk discount
      if (bulkDiscount > 0) {
        const individualDiscountValue = individualPrice * (bulkDiscount / 100);
        individualPrice = individualPrice - individualDiscountValue;
      }
      
      // Calculate Pix price
      let pixPrice = showIndividualDiscount ? individualPrice : totalPrice;
      if (pixDiscount > 0) {
        if (showIndividualDiscount) {
          // Apply Pix discount on individual price
          const discountValue = individualPrice * (pixDiscount / 100);
          pixPrice = individualPrice - discountValue;
        } else {
          // Apply Pix discount on total price
          const discountValue = totalPrice * (pixDiscount / 100);
          pixPrice = totalPrice - discountValue;
        }
      }
      
      // Update Pix price
      if (pixPriceEl) {
        pixPriceEl.textContent = formatMoney(pixPrice);
      }
      
      // Update compare price
      const compareWrapper = comparePriceEl ? comparePriceEl.closest('.sf-price-table__compare-wrapper') : null;
      if (comparePriceEl && comparePrice > 0) {
        if (showIndividualDiscount) {
          // Show individual compare price
          comparePriceEl.innerHTML = '<s>' + formatMoney(comparePrice) + '</s>';
        } else {
          // Show total compare price
          comparePriceEl.innerHTML = '<s>' + formatMoney(totalComparePrice) + '</s>';
        }
        if (compareWrapper) {
          compareWrapper.style.display = 'flex';
        }
      } else {
        if (comparePriceEl) {
          comparePriceEl.innerHTML = '';
        }
        if (compareWrapper) {
          compareWrapper.style.display = 'none';
        }
      }
      
      // Calculate card price
      if (cardPriceEl) {
        if (showIndividualDiscount) {
          cardPriceEl.textContent = formatMoney(individualPrice);
        } else {
          cardPriceEl.textContent = formatMoney(totalPrice);
        }
      }
      
      // Calculate installment value
      if (installmentValueEl && installments > 0) {
        const priceForInstallment = showIndividualDiscount ? individualPrice : totalPrice;
        const installmentValue = priceForInstallment / installments;
        installmentValueEl.textContent = formatMoney(installmentValue);
      }
      
      // Calculate Prime price (preço com desconto PIX - desconto Prime)
      let plusPrice = pixPrice;
      if (plusDiscount > 0) {
        const plusValue = pixPrice * (plusDiscount / 100);
        plusPrice = pixPrice - plusValue;
      }
      
      // Update Prime text
      if (plusTextEls.length > 0) {
        const plusTextTemplate = plusTextEls[0].dataset.plusTemplate || plusTextEls[0].textContent;
        const plusPriceFormatted = formatMoney(plusPrice);
        const updatedText = plusTextTemplate.replace(/\[preco-prime\]/g, plusPriceFormatted);
        plusTextEls.forEach(function(el) {
          el.textContent = updatedText;
        });
      }
    }
    
    // Initialize
    updatePrices(parseInt(slider.value) || 1);
    
    // Update on slider change
    slider.addEventListener('input', function() {
      updatePrices(parseInt(this.value) || 1);
    });
    
    // Modal functionality
    const modal = document.getElementById('sf-payment-modal-' + table.dataset.productId);
    const modalTrigger = table.querySelector('[data-modal-trigger]');
    
    if (modalTrigger && modal) {
      modalTrigger.addEventListener('click', function() {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    }
    
    const modalClose = modal ? modal.querySelectorAll('[data-modal-close]') : [];
    const paymentMethods = modal ? modal.querySelectorAll('[data-payment-method]') : [];
    const paymentDetails = modal ? modal.querySelector('[data-payment-details]') : null;
    const primeToggles = modal ? modal.querySelectorAll('[data-prime-option]') : [];
    const interestRatesStr = modal ? modal.dataset.interestRates || '' : '';
    const pixDiscountPercent = parseFloat(table.dataset.pixDiscountPercent) || 0;
    const enablePrime = modal ? modal.dataset.primeEnabled === 'true' : false;
    const primeDiscount = parseFloat(modal ? modal.dataset.primeDiscount || '0' : '0');
    const modalPriceDisplay = modal ? modal.dataset.modalPriceDisplay || 'quantity' : 'quantity';
    
    // Parse interest rates array
    let interestRates = [];
    if (interestRatesStr) {
      // Split by pipe separator
      const rates = interestRatesStr.split('|').filter(function(r) { return r.trim() !== ''; });
      interestRates = rates.map(function(rate) {
        // Replace comma with dot for decimal parsing (Brazilian format)
        const cleanRate = rate.trim().replace(',', '.');
        return parseFloat(cleanRate) || 0;
      });
    }
    
    let currentQuantity = parseInt(slider.value) || 1;
    let currentPaymentMethod = 'pix';
    let currentPrimeOption = 'without';
    
    function calculateInstallmentWithInterest(principal, installments, rate) {
      if (rate === 0 || installments === 0) {
        return principal / installments;
      }
      const monthlyRate = rate / 100;
      const installment = principal * (monthlyRate * Math.pow(1 + monthlyRate, installments)) / (Math.pow(1 + monthlyRate, installments) - 1);
      return installment;
    }
    
    function updateModalContent() {
      if (!paymentDetails) return;
      
      const bulkDiscount = getBulkDiscount(currentQuantity);
      let totalPrice = basePrice * currentQuantity;
      
      // Apply Prime discount first if customer is Prime
      if (isPrimeCustomer && plusDiscount > 0) {
        const primeDiscountValue = totalPrice * (plusDiscount / 100);
        totalPrice = totalPrice - primeDiscountValue;
      }
      
      if (bulkDiscount > 0) {
        const bulkDiscountValue = totalPrice * (bulkDiscount / 100);
        totalPrice = totalPrice - bulkDiscountValue;
      }
      
      // Apply PRIME discount if enabled and selected (para não-prime customers)
      if (!isPrimeCustomer && enablePrime && currentPrimeOption === 'with' && primeDiscount > 0) {
        const primeDiscountValue = totalPrice * (primeDiscount / 100);
        totalPrice = totalPrice - primeDiscountValue;
      }
      
      // Calculate individual price with Prime and bulk discounts
      let individualPrice = basePrice;
      
      // Apply Prime discount first if customer is Prime
      if (isPrimeCustomer && plusDiscount > 0) {
        const primeDiscountValue = individualPrice * (plusDiscount / 100);
        individualPrice = individualPrice - primeDiscountValue;
      }
      
      if (bulkDiscount > 0) {
        const individualDiscountValue = individualPrice * (bulkDiscount / 100);
        individualPrice = individualPrice - individualDiscountValue;
      }
      
      // Apply PRIME discount to individual price if enabled (para não-prime customers)
      if (!isPrimeCustomer && enablePrime && currentPrimeOption === 'with' && primeDiscount > 0) {
        const primeDiscountValue = individualPrice * (primeDiscount / 100);
        individualPrice = individualPrice - primeDiscountValue;
      }
      
      // Choose base price based on modal_price_display setting
      let basePriceForModal = modalPriceDisplay === 'unit' ? individualPrice : totalPrice;
      let quantityForModal = modalPriceDisplay === 'unit' ? 1 : currentQuantity;
      
      let finalPrice = basePriceForModal;
      let subtitle = '';
      let priceColor = '#10b981';
      
      if (currentPaymentMethod === 'pix') {
        if (pixDiscountPercent > 0) {
          const pixDiscountValue = basePriceForModal * (pixDiscountPercent / 100);
          finalPrice = basePriceForModal - pixDiscountValue;
          subtitle = 'À vista no PIX com ' + pixDiscountPercent + '% OFF';
        } else {
          finalPrice = basePriceForModal;
          subtitle = 'À vista no PIX';
        }
        priceColor = modal.dataset.pixPriceColor || '#10b981';
      } else if (currentPaymentMethod === 'card') {
        // Não mostrar preço e subtítulo para cartão
        subtitle = '';
        finalPrice = basePriceForModal;
      } else if (currentPaymentMethod === 'boleto') {
        if (pixDiscountPercent > 0) {
          const pixDiscountValue = basePriceForModal * (pixDiscountPercent / 100);
          finalPrice = basePriceForModal - pixDiscountValue;
        } else {
          finalPrice = basePriceForModal;
        }
        subtitle = 'À vista no boleto';
        priceColor = modal.dataset.boletoPriceColor || '#10b981';
      }
      
      let html = '';
      if (currentPaymentMethod !== 'card') {
        if (currentPaymentMethod === 'pix' || currentPaymentMethod === 'boleto') {
          html = '<div class="sf-payment-details__payment-box">';
          html += '<div class="sf-payment-details__price" style="color: ' + priceColor + ';">' + formatMoney(finalPrice) + '</div>';
          if (subtitle) {
            html += '<div class="sf-payment-details__subtitle">' + subtitle + '</div>';
          }
          html += '<div class="sf-payment-details__payment-info">';
          if (currentPaymentMethod === 'pix') {
            html += '<span>Pague com PIX e tenha seu pedido aprovado imediatamente</span>';
          } else if (currentPaymentMethod === 'boleto') {
            html += '<span>O boleto será gerado após a confirmação do pedido</span>';
          }
          html += '</div>';
          html += '</div>';
        } else {
          html = '<div class="sf-payment-details__price" style="color: ' + priceColor + ';">' + formatMoney(finalPrice) + '</div>';
          if (subtitle) {
            html += '<div class="sf-payment-details__subtitle">' + subtitle + '</div>';
          }
        }
      }
      
      if (currentPaymentMethod === 'card') {
        html += '<div class="sf-payment-details__installments">';
        for (let i = 1; i <= 12; i++) {
          let installmentValue, totalValue, interestRateForInstallment = 0;
          
          // Get interest rate for this specific installment
          if (interestRates.length >= i) {
            interestRateForInstallment = interestRates[i - 1];
          } else if (interestRates.length > 0) {
            interestRateForInstallment = interestRates[interestRates.length - 1];
          }
          
          // Use basePriceForModal for calculations (unit or quantity based on setting)
          // For card, we don't apply PIX discount, so use basePriceForModal (already has bulk and PRIME discounts)
          const priceForInstallment = modalPriceDisplay === 'unit' ? basePriceForModal : totalPrice;
          
          if (i <= installments && interestRateForInstallment === 0) {
            installmentValue = priceForInstallment / i;
            totalValue = priceForInstallment;
          } else {
            installmentValue = calculateInstallmentWithInterest(priceForInstallment, i, interestRateForInstallment);
            totalValue = installmentValue * i;
          }
          
          const interestText = (i > installments || interestRateForInstallment > 0) ? ' com juros' : ' sem juros';
          const installmentText = i === 1 ? 'À vista' : i + 'x de ' + formatMoney(installmentValue);
          
          html += '<div class="sf-payment-installment">';
          html += '<div class="sf-payment-installment__info">';
          html += '<span class="sf-payment-installment__text">' + installmentText + interestText + '</span>';
          html += '</div>';
          html += '<span class="sf-payment-installment__total"><strong>Total:</strong> ' + formatMoney(totalValue) + '</span>';
          html += '</div>';
        }
        html += '</div>';
      }
      
      paymentDetails.innerHTML = html;
    }
    
    // Open modal
    if (modalTrigger && modal) {
      modalTrigger.addEventListener('click', function() {
        currentQuantity = parseInt(slider.value) || 1;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        updateModalContent();
      });
    }
    
    // Close modal
    modalClose.forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function() {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });
    
    // Close on ESC key
    if (modal) {
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });
    }
    
    // Payment method selection
    paymentMethods.forEach(function(method) {
      method.addEventListener('click', function() {
        paymentMethods.forEach(function(m) {
          m.classList.remove('sf-payment-method--active');
        });
        this.classList.add('sf-payment-method--active');
        currentPaymentMethod = this.dataset.paymentMethod;
        updateModalContent();
      });
    });
    
    // PRIME toggle selection (apenas para não-Prime customers)
    if (!isPrimeCustomer) {
      primeToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function() {
          primeToggles.forEach(function(t) {
            t.classList.remove('sf-prime-toggle--active');
          });
          this.classList.add('sf-prime-toggle--active');
          currentPrimeOption = this.dataset.primeOption;
          updateModalContent();
        });
      });
    }
    
    // Update modal when quantity changes
    slider.addEventListener('input', function() {
      currentQuantity = parseInt(this.value) || 1;
      if (modal && modal.getAttribute('aria-hidden') === 'false') {
        updateModalContent();
      }
    });
    
    // Modal Prime de Assinatura - dentro do contexto da tabela
    const primeModalTrigger = table.querySelector('[data-prime-modal-trigger]');
    if (primeModalTrigger) {
      primeModalTrigger.addEventListener('change', function(e) {
        if (e.target.checked) {
          const productId = table.dataset.productId;
          const primeModal = document.getElementById('sf-prime-modal-' + productId);
          if (primeModal) {
            primeModal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        }
      });
      
      // Tornar o label clicável também
      const label = primeModalTrigger.closest('label');
      if (label) {
        label.addEventListener('click', function(e) {
          // Se clicar no texto, marcar a checkbox
          if (e.target.tagName === 'SPAN' || e.target.classList.contains('sf-price-table__prime-checkbox-text')) {
            e.preventDefault();
            primeModalTrigger.checked = !primeModalTrigger.checked;
            primeModalTrigger.dispatchEvent(new Event('change'));
          }
        });
      }
    }
  });
  
  // Função para processar texto com highlights [texto]
  function processBenefitHighlights() {
    const benefits = document.querySelectorAll('.sf-prime-modal__benefit span');
    benefits.forEach(function(benefit) {
      const text = benefit.textContent;
      // Procura por texto entre colchetes [texto]
      const regex = /\[([^\]]+)\]/g;
      if (regex.test(text)) {
        // Substitui [texto] por span estilizado
        const newHTML = text.replace(/\[([^\]]+)\]/g, '<span class="sf-prime-modal__benefit-highlight">$1</span>');
        benefit.innerHTML = newHTML;
      }
    });
  }
  
  // Função para substituir [PRIME] pela logo nas checkboxes
  function replacePrimeLogoInCheckboxes() {
    const checkboxTexts = document.querySelectorAll('[data-prime-checkbox-text]');
    checkboxTexts.forEach(function(textElement) {
      const logoUrl = textElement.getAttribute('data-prime-logo-url');
      const logoSize = textElement.getAttribute('data-prime-logo-size');
      
      if (logoUrl && logoUrl !== '') {
        const text = textElement.innerHTML;
        // Substitui [PRIME] pela logo
        const logoHTML = '<img src="' + logoUrl + '" alt="Prime" class="prime-logo-inline" style="width: ' + logoSize + '; height: auto; vertical-align: middle; display: inline-block; margin: 0 4px;">';
        const newHTML = text.replace(/\[PRIME\]/g, logoHTML);
        textElement.innerHTML = newHTML;
      }
    });
  }
  
  // Processar highlights e logos ao carregar a página
  processBenefitHighlights();
  replacePrimeLogoInCheckboxes();
  
  // Modal Prime - inicialização global (fechar modal, termos, adicionar ao carrinho)
  const primeModals = document.querySelectorAll('.sf-prime-modal');
  
  primeModals.forEach(function(modal) {
    const closeButtons = modal.querySelectorAll('[data-prime-modal-close]');
    const termsCheckbox = modal.querySelector('[data-prime-terms-checkbox]');
    const actionButton = modal.querySelector('[data-prime-modal-button]');
    const productVariantId = modal.dataset.primeProductId;
    
    // Fechar modal
    function closePrimeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Desmarcar checkbox quando fechar
      const checkbox = document.querySelector('[data-prime-modal-trigger]');
      if (checkbox) {
        checkbox.checked = false;
      }
    }
    
    closeButtons.forEach(function(btn) {
      btn.addEventListener('click', closePrimeModal);
    });
    
    // Fechar com ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closePrimeModal();
      }
    });
    
    // Validar termos e habilitar botão
    if (termsCheckbox && actionButton) {
      // Se há checkbox de termos, desabilitar botão inicialmente
      actionButton.disabled = !termsCheckbox.checked;
      termsCheckbox.addEventListener('change', function() {
        actionButton.disabled = !termsCheckbox.checked;
      });
    } else if (actionButton) {
      // Se não há checkbox de termos, habilitar botão automaticamente
      actionButton.disabled = false;
    }
    
    // Adicionar ao carrinho
    if (actionButton && productVariantId) {
      actionButton.addEventListener('click', function() {
        if (actionButton.disabled) return;
        
        const directCheckout = modal.dataset.primeDirectCheckout === 'true';
        
        actionButton.disabled = true;
        actionButton.textContent = 'Adicionando...';
        
        if (directCheckout) {
          // Modo checkout direto: limpar carrinho e adicionar apenas o produto Prime
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [{
                  id: parseInt(productVariantId),
                  quantity: 1
                }]
              })
            });
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            // Redirecionar para checkout
            window.location.href = '/checkout';
          })
          .catch(function(error) {
            console.error('Erro ao processar checkout direto:', error);
            actionButton.textContent = 'Erro - Tente novamente';
            actionButton.disabled = false;
            alert('Erro ao processar checkout. Tente novamente.');
          });
        } else {
          // Modo normal: adicionar ao carrinho e fechar modal
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(productVariantId),
                quantity: 1
              }]
            })
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {
            actionButton.textContent = modal.dataset.primeButtonText || 'Continuar';
            
            // Aguardar um pouco antes de fechar o modal e abrir o carrinho
            setTimeout(function() {
              closePrimeModal();
              
              // Atualizar cart_items global (se existir)
              if (typeof window.cart_items !== 'undefined') {
                window.cart_items = data.items;
              }
              
              // Método 1: Tema Halo - Atualizar e abrir carrinho
              if (typeof ella !== 'undefined') {
                if (typeof ella.updateDropdownCart === 'function') {
                  ella.updateDropdownCart();
                }
                if (typeof ella.getPopupShoppingCart === 'function') {
                  setTimeout(function() {
                    ella.getPopupShoppingCart(false, undefined);
                  }, 100);
                }
              }
              
              // Método 2: Click no ícone do carrinho (tema Halo)
              setTimeout(function() {
                const cartIcon = document.querySelector('.cart-icon, .js-cart-icon, [data-cart-icon], .header-cart, .icon-cart');
                if (cartIcon) {
                  cartIcon.click();
                }
              }, 200);
              
              // Método 3: Abrir cart dropdown/drawer diretamente
              setTimeout(function() {
                const cartDropdown = document.querySelector('.cart-dropdown, .cart_dropdown, #cart_dropdown, #header-cart-content');
                if (cartDropdown) {
                  cartDropdown.classList.add('is-open', 'open', 'active');
                  cartDropdown.style.display = 'block';
                }
              }, 300);
              
              // Método 4: Função genérica de update cart
              if (typeof window.onlyUpdateCart === 'function') {
                setTimeout(function() {
                  window.onlyUpdateCart();
                }, 100);
              }
              
              // Disparar eventos genéricos
              setTimeout(function() {
                document.dispatchEvent(new CustomEvent('cart:updated'));
                document.dispatchEvent(new CustomEvent('cart:open'));
              }, 150);
              
              // Callback do tema (se houver)
              if (window.theme && window.theme.cartUpdateCallback) {
                setTimeout(function() {
                  window.theme.cartUpdateCallback();
                }, 100);
              }
            }, 300);
          })
          .catch(function(error) {
            console.error('Erro ao adicionar produto ao carrinho:', error);
            actionButton.disabled = false;
            actionButton.textContent = modal.dataset.primeButtonText || 'Continuar';
            alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
          });
        }
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
